<template>
  <div class="content dis_center">
    <div></div>
    <div class="login_box dis_between">
      <div class="ipt_box">
        <img src="../../assets/logo.png" class="logo" alt="">
        <div class="login_title">杰诚工控项目管理系统</div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" @keyup.enter.native="submitForm('ruleForm')">
          <div class="dis_center ipt">
            <img class="img1" src="../../assets/1.png" alt="" />
            <el-form-item prop="username">
              <el-input v-model="ruleForm.username" placeholder="请输入用户名"></el-input>
            </el-form-item>
          </div>
          <div class="dis_center ipt">
            <img class="img2" src="../../assets/2.png" alt="" />
            <el-form-item prop="password"><el-input v-model="ruleForm.password" placeholder="请输入内容"
                type="password"></el-input></el-form-item>
          </div>
          <div class="dis remark" @click="toggleRememberPassword">
            <img v-if="rememberPassword" src="../../assets/71.png" class="i70" alt="">
            <img v-else src="../../assets/70.png" class="i70" alt="">
            <div>记住密码</div>
          </div>
          <el-form-item>
            <el-button type="primary" class="login_btn dis_center" @click="submitForm('ruleForm')">登 录</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { login } from "../js/api";
export default {
  data() {
    return {
      value1: "",
      value2: "",
      rememberPassword: false, // 记住密码复选框状态
      ruleForm: {
        //username和password默认为空
        username: "",
        password: "",
      },
      //rules前端验证
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
    };
  },

  mounted() {
    // 页面加载时检查是否有保存的用户名和密码
    this.loadRememberedCredentials();
  },

  methods: {
    // 切换记住密码状态
    toggleRememberPassword() {
      this.rememberPassword = !this.rememberPassword;
    },
    // 加载保存的用户名和密码
    loadRememberedCredentials() {
      const rememberedUsername = localStorage.getItem("rememberedUsername");
      const rememberedPassword = localStorage.getItem("rememberedPassword");
      const rememberPasswordChecked = localStorage.getItem("rememberPasswordChecked");
      
      if (rememberPasswordChecked === "true" && rememberedUsername && rememberedPassword) {
        this.ruleForm.username = rememberedUsername;
        this.ruleForm.password = rememberedPassword;
        this.rememberPassword = true;
      }
    },
    submitForm(formName) {
      let that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let json = that.ruleForm;

          // that.$router.replace("/userManagement");
          // return
          login(json).then((res) => {
            // console.log(res);
            if (res.code == 200) {
              // 如果勾选了记住密码，保存用户名和密码到localStorage
              if (that.rememberPassword) {
                localStorage.setItem("rememberedUsername", that.ruleForm.username);
                localStorage.setItem("rememberedPassword", that.ruleForm.password);
                localStorage.setItem("rememberPasswordChecked", "true");
              } else {
                // 如果没有勾选，清除之前保存的信息
                localStorage.removeItem("rememberedUsername");
                localStorage.removeItem("rememberedPassword");
                localStorage.removeItem("rememberPasswordChecked");
              }
              
              localStorage.setItem("id", res.data.id);
              localStorage.setItem("loginToken", res.data.loginToken);
              localStorage.setItem("userInfo", JSON.stringify(res.data));
              this.$message({
                message: "登录成功",
                type: "success",
              });
              //12小时后强制登出  配合main。js的路由
              // localStorage.setItem(
              //   "time",
              //   new Date().getTime() + 1000 * 3600 * 12
              // );
              that.$router.replace("/home");
            } else {
              this.$message({
                message: res.message,
                type: "warning",
              });
            }
          });
        }
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("./login.css");
</style>



// WEBPACK FOOTER //
// src/view/login/login.vue